<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="archive-inspiration single-page"
    id="help-page"
  >
    <PageHeader />
    <ModuleBuilder
      v-if="currentPage.acf && currentPage.acf.modules"
      class="modules"
      :modules="currentPage.acf.modules"
    />
    <FilteredPostsList
      taxonomy="inspir_taxonomy"
      postType="inspirasjon"
      :postTypes="['inspirasjon', 'video']"
      filters
      filtersMultiple
      filtersLogic="and"
      search
      searchPlaceholder="Søk i inspirasjon"
      key="inspir_taxonomy"
    />
    <VideoLightbox />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";
import VideoLightbox from "@/components/blocks/VideoLightbox";

export default {
  name: "archive-inspiration",
  components: {
    FilteredPostsList,
    VideoLightbox
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>
